import { Form, Formik } from 'formik';
import { FC } from 'react';

import { AuthFormHeader } from 'src/authentication/sections/AuthFormHeader/AuthFormHeader';
import { MICROCOPY } from 'src/data/microcopy/microcopyDictionary';
import { Button } from 'src/general/components/Button/Button';
import { FormikInput } from 'src/general/components/forms/FormikInput/FormikInput';
import { FormikOnErrorTracking } from 'src/general/components/forms/FormikOnErrorTracking/FormikOnErrorTracking';
import { getMicrocopy } from 'src/stores/microcopyStore';

import classes from './Forms.module.scss';
import { FormProps, ResetPasswordFormValidation, ResetPasswordFormValues } from './Forms.types';

interface Props extends FormProps<ResetPasswordFormValues> {
  email?: string;
}

const initialValues: ResetPasswordFormValues = {
  email: '',
};

export const ResetPasswordForm: FC<Props> = ({ onBack, onSubmit, onSubmitTracking, email }) => (
  <>
    <AuthFormHeader
      title={getMicrocopy(MICROCOPY.AUTHENTICATION_RESET_PASSWORD_FORM_TITLE)}
      subtitle={getMicrocopy(MICROCOPY.AUTHENTICATION_RESET_PASSWORD_FORM_CAPTION, true)}
      onBack={onBack}
    />
    <Formik
      initialValues={{ ...initialValues, email: email ?? initialValues.email }}
      onSubmit={onSubmit}
      validationSchema={ResetPasswordFormValidation}
    >
      {(props) => (
        <Form className={classes.form} noValidate>
          {!!onSubmitTracking && <FormikOnErrorTracking onError={onSubmitTracking} />}
          <FormikInput type="email" name="email" label="Email address" autoFocus />
          <footer className={classes.formFooter}>
            <Button
              type="submit"
              isLoading={props.isSubmitting}
              disabled={props.isSubmitting}
              fullWidth
              data-testid="submit"
            >
              Send me a reset link
            </Button>
          </footer>
        </Form>
      )}
    </Formik>
  </>
);
